import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useVisitor } from '../context/VisitorContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiShield, FiPlus, FiTrash2, FiAlertTriangle, FiCheck, FiRefreshCw, FiList, FiUpload } = FiIcons;

// Updated with your specific list
const DEFAULT_BLACKLIST = [
  // Major Cloud/ISP
  { pattern: 'Amazon', category: 'Cloud/ISP' },
  { pattern: 'AWS', category: 'Cloud/ISP' },
  { pattern: 'Google', category: 'Cloud/ISP' },
  { pattern: 'Microsoft', category: 'Cloud/ISP' },
  { pattern: 'Azure', category: 'Cloud/ISP' },
  { pattern: 'Cloudflare', category: 'CDN/Proxy' },
  { pattern: 'Facebook', category: 'Bot' },
  // Your Specific List
  { pattern: 'AGT NET', category: 'ISP' },
  { pattern: 'B Net Solutions', category: 'ISP' },
  { pattern: 'Beijing Baidu Netcom', category: 'Cloud' },
  { pattern: 'CLARO', category: 'ISP' },
  { pattern: 'COMUNICACI', category: 'ISP' },
  { pattern: 'CTINET', category: 'ISP' },
  { pattern: 'Chinanet', category: 'ISP' },
  { pattern: 'Cisco', category: 'Cloud/Security' },
  { pattern: 'Corporacion Laceibanetsociety', category: 'ISP' },
  { pattern: 'DEBIAN SIGNAL', category: 'ISP' },
  { pattern: 'Desktop Sigmanet', category: 'ISP' },
  { pattern: 'Digicel', category: 'ISP' },
  { pattern: 'ENTEL', category: 'ISP' },
  { pattern: 'Fortinet', category: 'Security' },
  { pattern: 'Fuzhou', category: 'ISP' },
  { pattern: 'GIGA FIBRA', category: 'ISP' },
  { pattern: 'HUAWEI', category: 'Cloud' },
  { pattern: 'Haerbing', category: 'ISP' },
  { pattern: 'Hengyang', category: 'ISP' },
  { pattern: 'Hor.net', category: 'ISP' },
  { pattern: 'Hutchison', category: 'ISP' },
  { pattern: 'Invista Net', category: 'ISP' },
  { pattern: 'Jinan', category: 'ISP' },
  { pattern: 'Jinhua', category: 'ISP' },
  { pattern: 'KPN', category: 'ISP' },
  { pattern: 'M net', category: 'ISP' },
  { pattern: 'M.M. Brito', category: 'ISP' },
  { pattern: 'MARVICNET', category: 'ISP' },
  { pattern: 'MEO SERVICOS', category: 'ISP' },
  { pattern: 'MOREIRANET', category: 'ISP' },
  { pattern: 'MZ NET', category: 'ISP' },
  { pattern: 'Manquehuenet', category: 'ISP' },
  { pattern: 'Metronet', category: 'ISP' },
  { pattern: 'Mse Servi', category: 'ISP' },
  { pattern: 'Mtn Nigeria', category: 'ISP' },
  { pattern: 'NOS COMUNICACOES', category: 'ISP' },
  { pattern: 'Netia', category: 'ISP' },
  { pattern: 'Netskope', category: 'Security' },
  { pattern: 'Next Layer', category: 'ISP' },
  { pattern: 'Ningbo', category: 'ISP' },
  { pattern: 'Optimum', category: 'ISP' },
  { pattern: 'Oracle', category: 'Cloud' },
  { pattern: 'P N NET', category: 'ISP' },
  { pattern: 'PT INDONESIA', category: 'ISP' },
  { pattern: 'PUNTONET', category: 'ISP' },
  { pattern: 'Planetel', category: 'ISP' },
  { pattern: 'Qingdao', category: 'ISP' },
  { pattern: 'Quanzhou', category: 'ISP' },
  { pattern: 'SCALEWAY', category: 'Cloud' },
  { pattern: 'SCON FIBRAS', category: 'ISP' },
  { pattern: 'Servicios Innovadores', category: 'ISP' },
  { pattern: 'Singnet', category: 'ISP' },
  { pattern: 'Singtel', category: 'ISP' },
  { pattern: 'Starhub', category: 'ISP' },
  { pattern: 'TELEF', category: 'ISP' },
  { pattern: 'TIM', category: 'ISP' },
  { pattern: 'TUSSA', category: 'ISP' },
  { pattern: 'Techtel', category: 'ISP' },
  { pattern: 'Telconet', category: 'ISP' },
  { pattern: 'Telekomunikasi', category: 'ISP' },
  { pattern: 'Telenet', category: 'ISP' },
  { pattern: 'Telenor', category: 'ISP' },
  { pattern: 'Telia', category: 'ISP' },
  { pattern: 'Telkom', category: 'ISP' },
  { pattern: 'Telstra', category: 'ISP' },
  { pattern: 'Tianjij', category: 'ISP' },
  { pattern: 'Turk Telekomunikasyon', category: 'ISP' },
  { pattern: 'UFINET', category: 'ISP' },
  { pattern: 'UNINET', category: 'ISP' },
  { pattern: 'Uzbektelekom', category: 'ISP' },
  { pattern: 'VTR', category: 'ISP' },
  { pattern: 'Viettel', category: 'ISP' },
  { pattern: 'Vnpt', category: 'ISP' },
  { pattern: 'Vodacom', category: 'ISP' },
  { pattern: 'Wavenet', category: 'ISP' },
  { pattern: 'Wenzhou', category: 'ISP' },
  { pattern: 'Worktitans', category: 'ISP' },
  { pattern: 'YELLOW CONNECT', category: 'ISP' },
  { pattern: 'ZSCALER', category: 'Security' }
];

const Blacklist = () => {
  const { blacklist, addToBlacklist, addBulkBlacklist, removeFromBlacklist, user } = useVisitor();
  const [newPattern, setNewPattern] = useState('');
  const [newCategory, setNewCategory] = useState('ISP');
  
  // Bulk Import State
  const [showBulk, setShowBulk] = useState(false);
  const [bulkText, setBulkText] = useState('');
  const [isAdding, setIsAdding] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPattern) {
      await addToBlacklist(newPattern, newCategory);
      setNewPattern('');
    }
  };

  const handleBulkSubmit = async (e) => {
    e.preventDefault();
    if (!bulkText.trim()) return;
    
    setIsAdding(true);
    const lines = bulkText.split(/\r?\n/).filter(line => line.trim().length > 0);
    const items = lines.map(line => ({
      pattern: line.trim(),
      category: newCategory
    }));

    await addBulkBlacklist(items);
    setBulkText('');
    setShowBulk(false);
    setIsAdding(false);
  };

  const loadDefaults = async () => {
    if (!window.confirm(`This will add ${DEFAULT_BLACKLIST.length} known ISPs and Cloud providers to your blacklist. Continue?`)) return;
    setIsAdding(true);
    // Filter out ones we already have
    const newItems = DEFAULT_BLACKLIST.filter(def => 
      !blacklist.some(b => b.pattern.toLowerCase().includes(def.pattern.toLowerCase()))
    );
    
    if (newItems.length > 0) {
      await addBulkBlacklist(newItems);
    }
    setIsAdding(false);
  };

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="p-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Blacklist</h1>
        <p className="text-gray-600">Manage blocked organizations, ISPs, and bots.</p>
      </div>

      {!user ? (
        <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 mb-6 flex items-start">
          <SafeIcon icon={FiAlertTriangle} className="text-orange-500 mt-1 mr-3 text-lg" />
          <div>
            <h3 className="font-semibold text-orange-900">Authentication Required</h3>
            <p className="text-sm text-orange-800">You must be logged in to manage the blacklist.</p>
          </div>
        </div>
      ) : (
        <>
          <div className="bg-white rounded-xl shadow-sm p-6 mb-8 border border-gray-100">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold text-gray-900">Add Blacklist Rules</h2>
              <div className="flex gap-2">
                 <button 
                  onClick={loadDefaults} 
                  disabled={isAdding}
                  className="text-sm text-green-700 bg-green-50 hover:bg-green-100 border border-green-200 px-3 py-2 rounded shadow-sm flex items-center transition-colors"
                >
                  {isAdding ? <SafeIcon icon={FiRefreshCw} className="animate-spin mr-2" /> : <SafeIcon icon={FiUpload} className="mr-2" />}
                  Load Known ISPs
                </button>
                <button 
                  onClick={() => setShowBulk(!showBulk)} 
                  className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center px-3 py-2"
                >
                  <SafeIcon icon={FiList} className="mr-1" />
                  {showBulk ? 'Single Add' : 'Bulk Import'}
                </button>
              </div>
            </div>

            {showBulk ? (
              <form onSubmit={handleBulkSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Paste List (One organization per line)
                  </label>
                  <textarea
                    rows={8}
                    placeholder="Example:&#10;AGT NET&#10;B Net Solutions&#10;Beijing Baidu Netcom"
                    value={bulkText}
                    onChange={(e) => setBulkText(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none font-mono text-sm"
                    required
                  />
                </div>
                <div className="flex justify-between items-center">
                   <div className="w-48">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Category for All</label>
                    <select
                      value={newCategory}
                      onChange={(e) => setNewCategory(e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                    >
                      <option value="ISP">ISP</option>
                      <option value="Cloud">Cloud / Data Center</option>
                      <option value="Bot">Bot / Crawler</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <button
                    type="submit"
                    disabled={isAdding}
                    className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 font-medium flex items-center"
                  >
                    {isAdding ? <SafeIcon icon={FiRefreshCw} className="animate-spin mr-2" /> : <SafeIcon icon={FiPlus} className="mr-2" />}
                    Import Lines
                  </button>
                </div>
              </form>
            ) : (
              <form onSubmit={handleSubmit} className="flex gap-4 items-end">
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Keyword / Pattern</label>
                  <input
                    type="text"
                    placeholder="e.g. Amazon Data Services"
                    value={newPattern}
                    onChange={(e) => setNewPattern(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                    required
                  />
                </div>
                <div className="w-48">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Type</label>
                  <select
                    value={newCategory}
                    onChange={(e) => setNewCategory(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                  >
                    <option value="ISP">ISP</option>
                    <option value="Cloud">Cloud / Data Center</option>
                    <option value="Bot">Bot / Crawler</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                <button
                  type="submit"
                  className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 font-medium flex items-center"
                >
                  <SafeIcon icon={FiPlus} className="mr-2" />
                  Add Rule
                </button>
              </form>
            )}
          </div>

          {/* List */}
          <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200">
            <div className="p-4 border-b border-gray-200 bg-gray-50">
              <h3 className="font-semibold text-gray-700">Active Rules ({blacklist.length})</h3>
            </div>
            
            {blacklist.length > 0 ? (
              <table className="w-full text-left">
                <thead>
                  <tr className="border-b border-gray-200">
                    <th className="p-4 font-medium text-gray-500 text-sm">Pattern</th>
                    <th className="p-4 font-medium text-gray-500 text-sm">Category</th>
                    <th className="p-4 font-medium text-gray-500 text-sm text-right">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {blacklist.map((item) => (
                    <tr key={item.id} className="border-b border-gray-100 hover:bg-gray-50">
                      <td className="p-4 font-mono text-gray-800">{item.pattern}</td>
                      <td className="p-4">
                        <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
                          item.category === 'ISP' ? 'bg-yellow-100 text-yellow-800' : 
                          item.category === 'Bot' ? 'bg-red-100 text-red-800' : 
                          'bg-blue-100 text-blue-800'
                        }`}>
                          {item.category}
                        </span>
                      </td>
                      <td className="p-4 text-right">
                        <button 
                          onClick={() => removeFromBlacklist(item.id)}
                          className="text-gray-400 hover:text-red-500 transition-colors"
                        >
                          <SafeIcon icon={FiTrash2} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="p-12 text-center text-gray-500">
                <SafeIcon icon={FiShield} className="text-4xl text-gray-300 mx-auto mb-3" />
                <p>No blacklist rules yet.</p>
                <p className="text-sm mt-2">Use "Load Known ISPs" to verify the predefined list.</p>
              </div>
            )}
          </div>
        </>
      )}
    </motion.div>
  );
};

export default Blacklist;